import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css/grid";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";
import CardReview from './CardReview'
import Rating from '@mui/material/Rating';


import AryoKusuma from "../img/Aryo-Kusuma.png"
import DianKartikasari from "../img/bu-dian.png"
import RoyPratama from "../img/Roy-Pratama.png"

export default () => {
  // https://randomuser.me/api/portraits/women/68.jpg
  // Props Avatar Testimoni
  const Avatar = () => {
    return <img src={AryoKusuma} alt="" /> 
  }
  const Avatar2 = () => {
    return <img src={DianKartikasari} alt="" /> 
  }
  const Avatar3 = () => {
    return <img src={RoyPratama} alt="" />
  }

  // Props Title
  const Title = () => {
    return <h5>Aryo Kusuma</h5>
  }
  const Title2 = () => {
    return <h5>Dian Kartikasari</h5>
  }
  const Title3 = () => {
    return <h5>Roy Pratama</h5>
  }

  // Props Review
  const Review = () => {
    return <p>"Pelayanan Mortara bagus dan komunikatif. Beberapa kali revisi juga diikuti dengan baik.
Hasilnya rapi dan detail, sesuai yang saya harapkan. Terima kasih Mortara, semoga tetap
konsisten ke depannya."</p>
  }
  const Review2 = () => {
    return <p>"Mortara sangat membantu proses renovasi rumah kami. Timnya mau mendengarkan
kebutuhan kami, menyesuaikan dengan budget, dan progresnya juga sesuai timeline.
Hasil akhirnya bagus dan sesuai ekspektasi kami."</p>
  }
  const Review3 = () => {
    return <p>"Mortara membangun proyek perumahan kami sesuai desain dan hasilnya rapi. Timnya
juga responsif, dan prosesnya cukup lancar dari awal sampai selesai. Kami puas dengan
hasil akhirnya."</p>
  }


  // Props Star
  const [value, setValue] = React.useState(5);
  const Star = () => {
    return <Rating name="read-only" value={value} readOnly />
  }
  const [value2, setValue2] = React.useState(5);
  const Star2 = () => {
    return <Rating name="read-only" value={value2} readOnly />
  }
  const [value3, setValue3] = React.useState(5);
  const Star3 = () => {
    return <Rating name="read-only" value={value3} readOnly />
  }

    return (
      <>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={0}
                        pagination={{
                        clickable: true,
                        }}
                        loop={true}
                        breakpoints={{
                        "@0.00": {
                            slidesPerView: 1,
                            spaceBetween: 10,
                        },
                        "@0.75": {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        "@1.00": {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                        "@1.50": {
                            slidesPerView: 3,
                            spaceBetween: 0,
                        },
                        }}
                        modules={[Pagination, Navigation]}
                        className="mySwiper"
                    >
                        <SwiperSlide className="p-5"><CardReview Avatar={Avatar()} title={Title()} Review={Review()} Star={Star()}/></SwiperSlide>
                        <SwiperSlide className="p-5"><CardReview Avatar={Avatar2()} title={Title2()} Review={Review2()} Star={Star2()}/></SwiperSlide>
                        <SwiperSlide className="p-5"><CardReview Avatar={Avatar3()} title={Title3()} Review={Review3()} Star={Star3()}/></SwiperSlide>
                    </Swiper>
      </>
    );
  }